"use strict";
exports.__esModule = true;
exports.P2P_WAITLIST_CONTENT = void 0;
exports.P2P_WAITLIST_CONTENT = {
    TITLE: 'We’re building a new product for you',
    BODY: 'Fill out your rental information and we’ll let you know when Flex is available for your property.',
    ERROR: 'All questions are required to submit',
    CTA: 'Submit',
    ONBOARDING_CTA: 'Continue',
    PAY_FIELD_LABEL: 'How do you currently pay rent?',
    PAY_FIELD_NAME: 'how_you_pay_rent',
    PAY_OPTIONS: [
        { label: 'Rent portal or property website', value: 'rent_portal_or_property_website' },
        { label: 'Cash, check or money order', value: 'cash_check_money_order' },
        { label: 'Venmo, Zelle, CashApp or PayPal', value: 'cashapp_paypal_venmo_zelle' },
        { label: 'Bank transfer (e.g., wire)', value: 'bank_or_wire' },
        { label: 'Other', value: 'other' },
    ],
    PAYMENT_CHANGE_FIELD_LABEL: 'Does your payment to your property change each month?',
    PAYMENT_CHANGE_FIELD_NAME: 'does_payment_to_property_change_each_month',
    PAYMENT_CHANGE_OPTIONS: [
        { label: 'Every month', value: 'every_month' },
        { label: 'Sometimes', value: 'sometimes' },
        { label: 'Never', value: 'never' },
    ],
    RENT_DUE_FIELD_LABEL: 'When is your rent due?',
    RENT_DUE_FIELD_NAME: 'when_is_rent_due',
    RENT_DUE_OPTIONS: [
        { label: '1st of the month', value: 'first_of_month' },
        { label: 'A different day than the 1st', value: 'different_day_than_first' },
        { label: 'It varies month-to-month', value: 'varies' },
    ],
    LANDLORD_PROPERTY_MANAGER_FIELD_LABEL: 'Please provide your landlord or property manager’s email',
    LANDLORD_PROPERTY_MANAGER_FIELD_NAME: 'landlord_property_manager_email',
    SUCCESS_BODY: 'While we’re building this product keep an eye on your email for updates.',
    SUCCESS_HEADING: 'You’re on the waitlist!',
    PLACEHOLDER: 'Please specify',
    FLEX_ANYWHERE_TITLE: 'You still have a way to pay your rent with Flex!',
    FLEX_ANYWHERE_BODY: 'Even though your property is not on Flex, you can use a Flex bank account for your rent.',
    FLEX_ANYWHERE_CTA: 'Learn more'
};
